export default __webpack_public_path__ + "static/media/welcomeMobile.78a9e14c.png";